import { useForm } from "react-hook-form";
import { MapContainer, Marker, Polygon, TileLayer, Tooltip, useMap } from "react-leaflet";
import { useMapEvents } from "react-leaflet/hooks";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useEffect, useState } from "react";
import { NavigateBeforeOutlined } from "@mui/icons-material";
import { actualizarBarrio } from "../handlers";

export default function ActualizarBarrio(props) {
  const [rta, setRta] = useState({
    data: null,
    error: null,
    params: null,
    loading: false,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
    getValues,
  } = useForm({
    defaultValues: props.barrio,
  });

  /* useEffect(() => {
        if (rta.data && rta.error == null) {
        }
    }, [rta]) */

  const [position, setPosition] = useState(
    props.barrio.poligonos.length > 0 ? props.barrio.poligonos : []
  );

  function LocationMarker(prop) {
    const map = useMapEvents({
      click(e) {
        const clickedLatLng = { lat: e.latlng.lat, lng: e.latlng.lng };
        setPosition((prevPuntos) => [...prevPuntos, clickedLatLng]);
      },
    });
    const ret = (
      <div>
        {position.map((item, index) => (
          <Marker key={index} position={item} icon={createPuntoIcon()}></Marker>
        ))}
        <Polygon pathOptions={purpleOptions} positions={position}>
          <Tooltip direction="bottom" offset={[0, 20]} opacity={1} permanent>
            {prop.values("nombre") != "" ? prop.values("nombre") : "Polígono del barrio"}
          </Tooltip>
        </Polygon>
      </div>
    );
    return position.length > 0 ? ret : null;
  }
  const purpleOptions = { color: "#F0701F" };

  const createPuntoIcon = () => {
    return L.divIcon({
      iconSize: [38, 95],
      iconAnchor: [5, 5],
      className: "number-icon",
      html: `<div style="position:relative; width:10px; height:10px; background-color:#F0701F; border-radius: 50%">
            </div>`,
    });
  };

  const enviar = async (datos) => {
    datos.poligonos = position;
    actualizarBarrio(rta, setRta, datos, datos.id);
  };

  return (
    <form className="mb-2" onSubmit={handleSubmit(enviar)}>
      <fieldset disabled={rta.loading}>
        <label>Nombre:</label>
        <input className="form-control" {...register("nombre")} type="text" />
        <div className="mt-1" style={{ height: "26px" }}>
          {errors.nombre && <span className="text-danger">{errors.nombre.message}</span>}
        </div>

        <label>Comision:</label>
        <input className="form-control" {...register("comision")} type="number" />
        <div className="mt-1" style={{ height: "26px" }}>
          {errors.comision && <span className="text-danger">{errors.comision.message}</span>}
        </div>

        <label>Dirección de comisión:</label>
        <input className="form-control" {...register("direccion")} type="text" />
        <div className="mt-1" style={{ height: "26px" }}>
          {errors.direccion && <span className="text-danger">{errors.direccion.message}</span>}
        </div>

        {/* aca va el mapita */}
        <div className="w-100 mb-5" style={{ height: "400px" }}>
          <div className="d-flex justify-content-between mb-2">
            <button
              type="button"
              onClick={() => {
                let asd = position;
                asd = asd.slice(0, asd.length - 1);
                setPosition(asd);
              }}
              className="btn btn-sm btn-danger"
              disabled={position.length == 0}
            >
              <NavigateBeforeOutlined /> Deshacer
            </button>
            <button
              type="button"
              disabled={position.length == 0}
              onClick={() => setPosition([])}
              className="btn btn-sm btn-primary"
            >
              Resetear puntos
            </button>
          </div>

          <MapContainer
            className="w-100 h-100"
            center={[-38.951252, -68.059187]}
            zoom={13}
            attributionControl={false}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <LocationMarker values={getValues} />
          </MapContainer>
        </div>

        <button type="submit" className="btn btn-sm btn-primary mt-2 d-flex">
          Guardar Barrio
          {rta.loading && (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status"></div>
            </div>
          )}
        </button>
      </fieldset>
    </form>
  );
}
